export const ROOT_ROUTE = '';
export const LOGIN_ROUTE = 'login';

export const REPORTS_ROOT_ROUTE = 'custom-reports';

export const HOME_ROUTE = 'home';
export const IFRAME_MODE = 'external_login';
